function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_579",
  "data-name": "Group 579",
  transform: "translate(-3227.407 -3153.786)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M3253.107,3154.078a8.535,8.535,0,0,1,5.756.478h0a8.54,8.54,0,0,0,7.088,0h0a8.545,8.545,0,0,1,10.5,2.814h0a8.543,8.543,0,0,0,6.139,3.544h0a8.547,8.547,0,0,1,7.688,7.688h0a8.543,8.543,0,0,0,3.544,6.139h0a8.546,8.546,0,0,1,2.814,10.5h0a8.541,8.541,0,0,0,0,7.088h0a8.546,8.546,0,0,1-2.814,10.5h0a8.543,8.543,0,0,0-3.544,6.139h0a8.545,8.545,0,0,1-7.688,7.687h0a8.549,8.549,0,0,0-6.139,3.545h0a8.544,8.544,0,0,1-10.5,2.813h0a8.543,8.543,0,0,0-7.088,0h0a8.544,8.544,0,0,1-10.5-2.813h0a8.549,8.549,0,0,0-6.139-3.545h0a8.543,8.543,0,0,1-7.687-7.687h0a8.549,8.549,0,0,0-3.545-6.139h0a8.544,8.544,0,0,1-2.813-10.5h0a8.551,8.551,0,0,0,0-7.088h0a8.544,8.544,0,0,1,2.813-10.5h0a8.549,8.549,0,0,0,3.545-6.139h0a8.545,8.545,0,0,1,7.687-7.688h0a8.543,8.543,0,0,0,6.139-3.544h0A8.526,8.526,0,0,1,3253.107,3154.078Z",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_36",
  "data-name": "Ellipse 36",
  cx: 29.15,
  cy: 29.15,
  r: 29.15,
  transform: "translate(3233.258 3159.636)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_65",
  "data-name": "Group 65"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  "data-name": "Path 70",
  d: "M3247.6,3179.574a5.209,5.209,0,0,0,4.2,5.1v-7.9h-4.2Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  "data-name": "Path 71",
  d: "M3273.011,3184.677a5.209,5.209,0,0,0,4.2-5.1v-2.8h-4.2Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  "data-name": "Path 72",
  d: "M3273.011,3172.771v-3.115H3251.8v3.115h-8.2v6.8a9.208,9.208,0,0,0,8.918,9.189,10.668,10.668,0,0,0,7.728,6.592v3.306a7.745,7.745,0,0,0-4.909,4.37h14.138a7.737,7.737,0,0,0-4.909-4.37v-3.306a10.664,10.664,0,0,0,7.728-6.592,9.207,9.207,0,0,0,8.918-9.189v-6.8Zm-21.207,11.906a5.209,5.209,0,0,1-4.2-5.1v-2.8h4.2Zm16.015,3.877h-10.154v-2.311l4.882-4.564c1.043-.969,1.192-1.564,1.192-2.1,0-.838-.559-1.341-1.677-1.341a2.666,2.666,0,0,0-2.329,1.266l-2.738-1.527a5.975,5.975,0,0,1,5.4-2.721c3,0,5.068,1.547,5.068,3.969,0,1.267-.354,2.422-2.217,4.136l-2.459,2.273h5.03Zm9.393-8.98a5.209,5.209,0,0,1-4.2,5.1v-7.9h4.2Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_64",
  "data-name": "Group 64"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  "data-name": "Path 73",
  d: "M3265.431,3207.721h.464l-.232-.577Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  "data-name": "Path 74",
  d: "M3247.093,3205.372v4.284h30.628v-4.284Zm5.32,3.077-.005-.957-.464.779h-.227l-.462-.753v.931h-.471v-1.8h.419l.635,1.041.619-1.041h.42l.005,1.8Zm2.188,0-.143-.351h-.762l-.143.351h-.52l.8-1.8h.5l.8,1.8Zm2.4,0h-.42l-.8-.962v.962h-.5v-1.8h.419l.8.962v-.962h.5Zm.877,0h-.51v-1.8h.51Zm1.783-1.41h-.906v.4h.8v.4h-.8v.619h-.51v-1.8h1.416Zm1.692,1.41H3259.9v-1.8h1.416v.4h-.911v.3h.8v.381h-.8v.331h.944Zm.922.036a1.433,1.433,0,0,1-.761-.2l.168-.377a1.147,1.147,0,0,0,.6.178c.212,0,.294-.059.294-.147,0-.286-1.027-.077-1.027-.748,0-.322.263-.585.8-.585a1.352,1.352,0,0,1,.654.157l-.157.379a1.077,1.077,0,0,0-.5-.139c-.214,0-.291.072-.291.163,0,.275,1.024.069,1.024.734C3263.072,3208.217,3262.809,3208.485,3262.272,3208.485Zm1.907-.036h-.511v-1.4h-.553v-.405h1.616v.405h-.552Zm2.008,0-.143-.351h-.762l-.143.351h-.521l.8-1.8h.5l.8,1.8Zm2.207,0h-1.617v-.319l.911-1.081h-.888v-.405h1.555v.32l-.91,1.08h.949Zm.739,0h-.511v-1.8h.511Zm1.277.036a.941.941,0,1,1,1-.938A.943.943,0,0,1,3270.41,3208.485Zm2.993-.036h-.42l-.8-.962v.962h-.5v-1.8h.42l.8.962v-.962h.5Zm.877,0h-.511v-1.8h.511Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_38",
  "data-name": "Ellipse 38",
  cx: 0.487,
  cy: 0.516,
  rx: 0.487,
  ry: 0.516,
  transform: "translate(3269.922 3207.031)",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  "data-name": "Path 75",
  d: "M3253.845,3207.721h.464l-.232-.577Z",
  fill: "#fbb03b"
}))));

var SvgSecondPlaceManifestation = function SvgSecondPlaceManifestation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecondPlaceManifestation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/second-place-manifestation.54287666.svg";
export { ForwardRef as ReactComponent };